import {gql} from "@apollo/client";

export const RESPONSE_FRAGMENT = gql`
    fragment ResponseFragment on Response {
        success
        error
    }
`;